module.exports = __webpack_public_path__ + "img/96sdriver.2ed25442.jpg";